<template>
  <div class="Panel">
    
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          {{data.title}}<span class="range" v-if="mode=='charts'">({{range_str}}) </span>
        </p>
        <a href="#" class="card-header-icon" aria-label="more options">
          <span class="icon">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
        </a>
      </header>
      <div class="card-content">
        <div class="content">
          <div v-if="mode=='charts'">
            <Chart :data = data></Chart>
          </div>
          <div v-if="mode=='dashboard'">
            <div class="columns">
              <div class="column is-2">
                
                    <label class="label is-small">Status czujników</label>
                
                
                <hr>
                <Status :data="data"></Status>
              </div>
              <div class="column  is-3">
                
                    <label class="label is-small">Ostatni pomiar</label>
                
                
                <hr>
                <Chartjs :data="data"></Chartjs>
              </div>
              <div  v-if="role == 0" class="column  is-3">
              
                
                    <label class="label is-small">Ostatni pomiar</label>
                
                
                <hr>
                <CurrentTemperatures :data="data"></CurrentTemperatures>
              </div>
              <div v-else class="column  is-7">
              
                
                    <label class="label is-small">Ostatni pomiar</label>
                
                
                <hr>
                <CurrentTemperatures :data="data"></CurrentTemperatures>
              </div>
              <div v-if="role == 0" class="column  is-4">
              
                
                    <label class="label is-small">Wartości min i max</label>
                
                
                <hr>
                <MinMax :data="data"></MinMax>
              </div>
              
            </div>
            
            
            
          </div>
        </div>
      </div>

      <footer v-if="mode=='charts'" class="card-footer">
        
        <a  class="card-footer-item" @click="range(1)">1 dzień</a>
        <a  class="card-footer-item" @click="range(3)">3 dni</a>
        <a  class="card-footer-item" @click="range(7)">7 dni</a>
      </footer>
    </div>
    
   
  </div>
</template>

<script>
import Chart from '@/components/Chart.vue'
import Status from '@/components/Status.vue'
import Chartjs from '@/components/Chartjs.vue'
import CurrentTemperatures from '@/components/CurrentTemperatures.vue'
import MinMax from '@/components/MinMax.vue'

export default {
  name: 'Panel',
  components: {
    Chart,
    Status,
    Chartjs,
    CurrentTemperatures,
    MinMax,  

  },
  computed: {
          
    role(){
      return this.$store.getters.role
    }
  },
  props: {
    data: Object,
    mode: String
  },
  data() {
    return {
      range_str: "1 dzień",
    }
  },
  mounted () {
    
    
  },
  methods: {
    range(_range){
      //this.range = _range;
      if (_range == 1){
        this.range_str = "1 dzień"
      }else if (_range == 3){
        this.range_str = "3 dni"
      }else if (_range == 7){
        this.range_str = "7 dni"
      }
      
      var objData = {
        id: this.data.id,
        range: _range,

      }
      this.$store.dispatch('getAllData', objData);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .Panel .card{
    margin: 10px;
    
  }
  
  .Panel .graphdiv{
    width: auto;
    height: 300px;
  }
  .dygraph-legend{
    float: right;
  }
  .Panel .range{
    margin-left: 10px;
  }
  .card .card-content{
    background-color: #333 !important;
  }
  .card .card-footer{
    background-color: #333 !important;
  }
</style>
